import {
    useEffect,
    useState,
} from "react";

import api from "../../api/api";

import AdminLayout from "./Components/AdminLayout";
import BestServedWithModal from "./Components/BestServedWithModal";

export default function AdminBestServedWith() {
    const [bestServedWith, setBestServedWith] =
        useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    const [selectedItem, setSelectedItem] =
        useState<any>(null);

    const loadItems = async () => {
        const response = await api.get("/best-served-with");

        setBestServedWith(response.data.best_served_with);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const handleSave = async (
        data: FormData
    ) => {
        if (selectedItem) {
            await api.post(
                `/best-served-with/${selectedItem.id}?_method=PUT`,
                data,
                {
                    headers: {
                        "Content-Type":
                            "multipart/form-data",
                    },
                }
            );
        } else {
            await api.post(
                "/best-served-with",
                data,
                {
                    headers: {
                        "Content-Type":
                            "multipart/form-data",
                    },
                }
            );
        }

        setModalOpen(false);
        setSelectedItem(null);

        loadItems();
    };

    const handleDelete = async (
        id: number
    ) => {
        if (
            !window.confirm(
                "Delete this item?"
            )
        ) {
            return;
        }

        await api.delete(
            `/best-served-with/${id}`
        );

        loadItems();
    };

    const moveUp = async (
        index: number
    ) => {
        if (index <= 0) return;

        const updated = [...bestServedWith];

        [
            updated[index - 1],
            updated[index],
        ] = [
            updated[index],
            updated[index - 1],
        ];

        setBestServedWith(updated);

        await api.post(
            "/best-served-with/reorder",
            {
                best_served_with:
                    updated.map(
                        (item, position) => ({
                            id: item.id,
                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadItems();
    };

    const moveDown = async (
        index: number
    ) => {
        if (
            index >=
            bestServedWith.length - 1
        )
            return;

        const updated = [...bestServedWith];

        [
            updated[index],
            updated[index + 1],
        ] = [
            updated[index + 1],
            updated[index],
        ];

        setBestServedWith(updated);

        await api.post(
            "/best-served-with/reorder",
            {
                best_served_with:
                    updated.map(
                        (item, position) => ({
                            id: item.id,
                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadItems();
    };

    return (
        <AdminLayout>
            <div className="page-header">
                <h1>
                    Best Served With
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {
                        setSelectedItem(
                            null
                        );
                        setModalOpen(
                            true
                        );
                    }}
                >
                    Add Item
                </button>
            </div>

            <table className="users-table">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Active</th>
                    <th>Actions</th>
                </tr>
                </thead>

                <tbody>
                {bestServedWith.map(
                    (
                        item,
                        index
                    ) => (
                        <tr
                            key={
                                item.id
                            }
                        >
                            <td>
                                {
                                    item.name
                                }
                            </td>

                            <td>
                                {item.is_active
                                    ? "Yes"
                                    : "No"}
                            </td>

                            <td>
                                <div className="actions">
                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {
                                            setSelectedItem(
                                                item
                                            );
                                            setModalOpen(
                                                true
                                            );
                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                item.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>
                                </div>
                            </td>
                        </tr>
                    )
                )}
                </tbody>
            </table>

            {modalOpen && (
                <BestServedWithModal
                    bestServedWith={
                        selectedItem
                    }
                    onClose={() =>
                        setModalOpen(
                            false
                        )
                    }
                    onSave={
                        handleSave
                    }
                />
            )}
        </AdminLayout>
    );
}
